import React from 'react';
import { TrendingUp, TrendingDown, Minus, LucideIcon } from 'lucide-react';

interface MetricCardProps {
  label: string;
  value: string;
  change?: number;
  changeLabel?: string;
  icon: LucideIcon;
  iconColor?: string;
  iconBg?: string;
  className?: string;
  onClick?: () => void;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  change,
  changeLabel,
  icon: Icon,
  iconColor = 'text-brand-400',
  iconBg = 'bg-brand-50',
  className = '',
  onClick,
}) => {
  const TrendIcon = change && change > 0 ? TrendingUp : change && change < 0 ? TrendingDown : Minus;
  const trendColor = change && change > 0 ? 'text-emerald-600' : change && change < 0 ? 'text-red-500' : 'text-surface-400';

  return (
    <div
      className={`glass-card p-5 animate-fade-in ${onClick ? 'cursor-pointer hover:shadow-md hover:border-brand-200/60 transition-all' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div className="space-y-3">
          <p className="metric-label">{label}</p>
          <p className="metric-value">{value}</p>
          {change !== undefined && (
            <div className="flex items-center gap-1.5">
              <TrendIcon size={13} className={trendColor} />
              <span className={`text-xs font-medium ${trendColor}`}>
                {change > 0 ? '+' : ''}{change}%
              </span>
              {changeLabel && (
                <span className="text-xs text-surface-400">{changeLabel}</span>
              )}
            </div>
          )}
        </div>
        <div className={`w-10 h-10 rounded-xl ${iconBg} flex items-center justify-center`}>
          <Icon size={20} className={iconColor} />
        </div>
      </div>
    </div>
  );
};

